import { KeyboardEvent, ReactNode } from "react";
import { Grid, IconButton } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { cls } from "itsf-ui-common";
import { Switch } from "@common/Switch";
import { useStyle } from "../../ProductLine/style";

interface IParams {
    isMobile: boolean;
    extraComponent?: ReactNode;
    checkboxId: string;
    checkboxTitle: string;
    isChecked: boolean;
    onChangeCheckbox: () => void;
    onKeyDown?: (event: KeyboardEvent<HTMLLabelElement>) => void;
    checkedDetailsComponent?: ReactNode;
    onClickEditCheckedDetails?: () => void;
}

export const ProductLineCheckbox = (props: IParams) => {
    const {
        isMobile,
        checkboxId,
        checkboxTitle,
        isChecked,
        onChangeCheckbox,
        onKeyDown,
        checkedDetailsComponent,
        extraComponent,
        onClickEditCheckedDetails,
    } = props;
    const { classes } = useStyle();

    return (
        <>
            {extraComponent && (
                <Grid alignItems="center" className={cls(classes.switch, classes.extraComponent)} container>
                    {extraComponent}
                </Grid>
            )}
            <Grid alignItems="center" className={classes.switch} container wrap="nowrap">
                <Grid item>
                    <Switch
                        ariaLabelledby={`label-${checkboxId}`}
                        checked={isChecked}
                        className={classes.switchCheckbox}
                        dataTestId={`toggle-${checkboxId}-button`}
                        fullWidth={false}
                        id={checkboxId}
                        inputClassName="xtest_switch_button"
                        label={checkboxTitle}
                        labelFontWeight={"default"}
                        onChange={() => onChangeCheckbox()}
                        onKeyDown={onKeyDown}
                    />
                </Grid>
                {checkedDetailsComponent && !isMobile && (
                    <>
                        <Grid className={classes.checkedDetailsDesktop} item>
                            {checkedDetailsComponent}
                        </Grid>
                        <Grid item>
                            <IconButton
                                aria-label="Edit"
                                className={cls("xtest_edit_button", classes.iconButton)}
                                color="inherit"
                                data-testid={`edit-${checkboxId}-button`}
                                size="large"
                                onClick={onClickEditCheckedDetails}
                            >
                                <Edit />
                            </IconButton>
                        </Grid>
                    </>
                )}
            </Grid>
            {checkedDetailsComponent && isMobile && (
                <Grid alignItems="center" className={classes.switch} container justifyContent="space-between">
                    <Grid item sm={9} xs={9}>
                        {checkedDetailsComponent}
                    </Grid>
                    <Grid alignItems="center" display="flex" item justifyContent="flex-end" sm={3} xs={3}>
                        <IconButton
                            aria-label="Edit"
                            className={cls("xtest_edit_button", classes.iconButton)}
                            color="inherit"
                            data-testid={`edit-${checkboxId}-button`}
                            size="large"
                            onClick={onClickEditCheckedDetails}
                        >
                            <Edit />
                        </IconButton>
                    </Grid>
                </Grid>
            )}
        </>
    );
};
